export default "/_next/static/images/338f546a7b6038626c73869099b4f37b.jpg";